import React from "react";
import usePageMeta from "@/lib/usePageMeta";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "What areas do you service?", a: "We service Albury, Wodonga and surrounding towns. Not sure if we cover your address? Just give us a call." },
  { q: "Are you licensed and insured?", a: "Yes. We carry public liability insurance and engage licensed trades for any specialised plumbing or electrical work that requires it." },
  { q: "Do you offer free quotes?", a: "Always. Send us photos via the quote form or contact page and we'll get back to you shortly." },
  { q: "How quickly can you start?", a: "Most small jobs can be booked within the same week. Emergency call-outs are available for urgent issues like leaks or lock-outs." },
  { q: "Do you handle large or recurring jobs?", a: "Yes — we work with homeowners, property managers and investors on one-off jobs and ongoing maintenance packages." },
  { q: "What's your payment policy?", a: "No deposits for standard jobs. You pay once you're happy with the work, by bank transfer or card." },
  { q: "Do you provide a workmanship guarantee?", a: "Yes. If you're not happy with the work, we come back and make it right at no extra cost." },
  { q: "Can you supply the materials?", a: "Yes, we can supply materials at trade pricing, or you can supply your own — whichever you prefer." },
];

export default function FAQ() {
  usePageMeta({ title: "FAQ", path: "/faq", description: "Common questions about our maintenance, repair and cleaning services in Albury/Wodonga — pricing, licensing and more." });
  return (
    <div data-testid="faq-page">
      <section data-nav-theme="dark" className="bg-navy-deep text-white py-20 min-h-[60vh] flex items-center">
        <div className="max-w-7xl mx-auto px-5 md:px-8 w-full">
          <div className="eyebrow">Frequently asked</div>
          <h1 className="font-display display-lg tracking-wide mt-3 leading-tight">Quick answers.</h1>
        </div>
      </section>
      <section data-nav-theme="light" className="max-w-3xl mx-auto px-5 md:px-8 py-16">
        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((f) => (
            <AccordionItem key={f.q} value={f.q} className="bg-white border border-slate-200 rounded-sm px-5">
              <AccordionTrigger className="text-left font-display font-bold text-navy hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-700 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
